<template>
	<!-- 2 div container for mobile horizontal scrolling -->
	<div class="overflow-x-auto -mx-4 sm:-mx-6 -mb-4">
		<div class="inline-block min-w-full py-2 align-middle px-4 sm:px-6 pb-4">
			<div class="overflow-hidden shadow bg-white rounded-lg sm:rounded-xl">
				<table class="min-w-full divide-y divide-gray-300">
					<thead>
						<tr>
							<th
								scope="col"
								class="px-4 py-3.5 text-left font-semibold text-gray-500"
							>
								{{ __("Article") }}
							</th>
							<th
								scope="col"
								class="px-0 py-3.5 text-left font-semibold text-gray-500"
							>
								<span class="hidden sm:block">{{ __("Total Quantity") }}</span>
							</th>
							<th
								scope="col"
								class="px-0 py-3.5 text-left font-semibold text-gray-500"
							>
								<span class="hidden sm:block">{{ __("Average price") }}</span>
								<span class="sm:hidden">{{ __("Price") }}</span>
							</th>
							<th
								scope="col"
								class="pl-4 py-3.5 text-left font-semibold text-gray-500"
							>
								{{ __("Revenue") }}
							</th>
							<th
								scope="col"
								class="pr-4 py-3.5 text-left font-semibold text-gray-500 text-right"
							>
								{{ __("Contracts") }}
							</th>
						</tr>
					</thead>
					<tbody class="divide-y divide-gray-200 bg-white">
						<tr v-for="grade in byGrade">
							<td class="whitespace-nowrap px-4 py-4 text-gray-500">
								{{
									$cropOptions.getLocalizedLabel(
										grade.product__grade,
										$cropOptions.productGradeOptions
									)
								}}
								<a
									href="#"
									v-if="getTickerCode(grade.product__type) !== null"
									class="ml-1 text-orange-500"
									v-on:click="
										$bus.$emit(
											'toggle-iframe-modal',
											$route('my_contracts.matif_chart', {
												tickerCode: grade.product__grade,
												year: currentYear,
												filterType: filterType,
											})
										)
									"
									>{{ __("Details") }} &raquo;</a
								>
							</td>
							<td class="whitespace-nowrap px-0 py-0 text-gray-500">
								<my-contracts-horizontal-barchart
									class="hidden sm:block"
									:maximum="maximumQtyByGrade"
									:values="[grade.qty]"
									:key="
										'BARCHART_' +
										grade.product__grade +
										JSON.stringify(grade.qty)
									"
									:color="
										$cropOptions.dashboardArticleColoring[grade.product__type]
									"
								/>
							</td>
							<td
								class="sm:whitespace-nowrap leading-4 sm:leading-6 px-0 py-4 xl:py-0 text-gray-500 sm:flex items-center"
							>
								<div class="hidden xl:block">
									<my-contracts-errorchart
										class="hidden sm:block"
										:category-data="[grade.product__grade]"
										:data="grade.price__mt"
										:chart-interval="chartInterval"
										:key="
											'ERRORCHART_' +
											grade.product__grade +
											JSON.stringify(grade.price__mt)
										"
									/>
								</div>
								<div class="sm:whitespace-nowrap">
									<!-- {{ JSON.stringify(grade.price__mt) }} -->
									<!-- {{ chartInterval }} -->
									<span
										class="text-xs pl-1"
										v-if="grade.price__mt.min != grade.price__mt.max"
									>
										&Oslash;
									</span>
									{{
										grade.price__mt.mean.toLocaleString(locale, {
											minimumFractionDigits: 2,
											maximumFractionDigits: 2,
										})
									}}
									€/t
									<span
										class="text-xs pl-1 whitespace-nowrap hidden sm:block"
										v-if="grade.price__mt.min != grade.price__mt.max"
									>
										({{
											grade.price__mt.min.toLocaleString(locale, {
												minimumFractionDigits: 2,
												maximumFractionDigits: 2,
											})
										}}–
										{{
											grade.price__mt.max.toLocaleString(locale, {
												minimumFractionDigits: 2,
												maximumFractionDigits: 2,
											})
										}}
										€/t)
									</span>
								</div>
							</td>
							<td class="whitespace-nowrap pl-4 py-4 text-gray-500">
								{{
									(1 * grade.revenue).toLocaleString(locale, {
										minimumFractionDigits: 0,
										maximumFractionDigits: 0,
									})
								}}
								€
							</td>
							<td class="whitespace-nowrap px-4 py-4 text-gray-500 text-right">
								{{ grade.count }}
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</div>
</template>

<script>
import { groupBy, sum, min, max, mean, range } from "lodash";
export default {
	props: {
		byGradeData: {
			type: Array,
			default: () => [],
		},
		filterType: {
			type: String,
			required: true,
		},
	},
	data() {
		return {
			currentYear: new Date().getFullYear(),
		};
	},
	computed: {
		byGrade() {
			// Aggregate kommen serverseitig (MyContractsSummaryService); hier nur noch die
			// Anzeige-Sortierung nach der Artikel-Reihenfolge.
			let priceOrder = this.$cropOptions.articleCustomSortOrder;

			return [...this.byGradeData].sort((a, b) => {
				if (priceOrder[a.product__grade] > priceOrder[b.product__grade]) {
					return 1;
				} else if (priceOrder[a.product__grade] < priceOrder[b.product__grade]) {
					return -1;
				}
			});
		},
		maximumQtyByGrade() {
			let maximum = 0;
			const grades = this.byGrade;
			for (const grade of grades) {
				maximum = grade.qty > maximum ? grade.qty : maximum;
			}
			return maximum;
		},
		chartInterval() {
			let val_min = min(this.byGrade.map((g) => g.price__mt.min)),
				val_max = max(this.byGrade.map((g) => g.price__mt.max)),
				range = val_max - val_min + 10;

			let interval = [
				Math.floor((val_min - range / 5) / 10) * 10,
				Math.ceil((val_max + range / 5) / 10) * 10,
			];
			return interval;
		},
	},
	methods: {
		getTickerCode(productType) {
			if (productType == "MAIZE") {
				return null;
			} else if (productType == "RAPE" || productType == "SOYBEANS") {
				return "ECO";
			} else {
				return "EBM";
			}
		},
	},
};
</script>
